export const thumbnails = new Map([
  ['diversidade-pl1q5', 'img/onboarding/complementary-thumbs/diversidade.png'],
  [
    'negociacao-estrategica-phd4y',
    'img/onboarding/complementary-thumbs/negociacao-estrategica.png',
  ],
  [
    'combo-de-inteligencia-artificial-n5ygh',
    'img/onboarding/complementary-thumbs/combo-de-inteligencia-artificial.png',
  ],
  ['excel-basico-pdeva', 'img/onboarding/complementary-thumbs/excel-basico.png'],
  [
    'introducao-ao-desenvolvimento-web-ppg8u',
    'img/onboarding/complementary-thumbs/introducao-ao-desenvolvimento-web.png',
  ],
  [
    'produtividade-e-organizacao-pmn1i',
    'img/onboarding/complementary-thumbs/produtividade-e-organizacao.png',
  ],
  [
    'soft-skills-com-porta-dos-fundos-vd5de',
    'img/onboarding/complementary-thumbs/soft-skills-com-porta-dos-fundos.png',
  ],
  [
    'tecnicas-e-ferramentas-para-projetos-peuqe',
    'img/onboarding/complementary-thumbs/tecnicas-e-ferramentas-para-projetos.png',
  ],
]);
